import translate from '@common/localization/translate';

const translator = {
  methods: {
    tr: (lbl, params = []) => translate(lbl, params),
  },
};
export default translator;
